import React from 'react';
import PropTypes from 'prop-types';
import { FormSection, Field } from 'redux-form';
import { Checkbox } from 'redux-form-material-ui';

const PERMISSIONS = [
    {
        key: 'htmlWidgets',
        label: 'HTML Widgets'
    },
    {
        key: 'smWidgets',
        label: 'Social media widgets'
    },
    {
        key: 'campaigns',
        label: 'Campaigns/automations'
    },
    {
        key: 'messageServices',
        label: 'Message services'
    },
    {
        key: 'tvSchedule',
        label: 'TV Schedule'
    },
    {
        key: 'gridMakerTool',
        label: 'Grid Maker Tool'
    }
];

const listRender = PERMISSIONS.map(permission => {
    return (
        <Field
            key={permission.key}
            name={permission.key}
            label={permission.label}
            normalize={v => Boolean(v)}
            component={Checkbox}
        />
    );
});

function PermissionsForm({ ListWrapper }) {
    return (
        <FormSection name="permissions">
            {ListWrapper ? <ListWrapper>{listRender}</ListWrapper> : listRender}
        </FormSection>
    );
}

PermissionsForm.propTypes = {
    ListWrapper: PropTypes.func
};

export default PermissionsForm;



/** WEBPACK FOOTER **
 ** ../src/dash/front/admin/components/Account/forms/PermissionsForm.js
 **/